import React from 'react'

import moment from 'moment'

import { Date } from '../../types'

import css from './Title.css'

const unique = (arr: string[]) => Array.from(new Set(arr))

const getMonthsFromDates = (dates: Date[]) =>
  unique(
    dates
      .map((date) => moment(date.date, 'YYYY-MM-DD'))
      .sort((a, b) => a.diff(b))
      .map((date) => date.format('MMMM YYYY')),
  )

type DatesPropType = {
  dates: Date[]
}

const Title = ({ dates }: DatesPropType) => (
  <span className={css.title}>{getMonthsFromDates(dates).join(' / ')}</span>
)

export { Title }
